Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    bottomSheetMinHeight: 40,
    bottomSheetSpacingInset: 8,
    bottomSheetElevation: 60,
    bottomSheetMotionTiming: "200ms",
    bottomSheetMotionFunction: "ease",
    bottomSheetBackgroundColor: tokens.themeBackgroundAlternatePrimaryDefault,
    bottomSheetShadowOffsetX: 0,
    bottomSheetShadowOffsetY: -4,
    bottomSheetShadowBlur: 8,
    bottomSheetShadowSpread: 0,
    bottomSheetShadowColor: "rgba(11, 12, 12, 0.16)"
  }
};